import { WifiOff } from 'lucide-react';
import { Button } from '@jeraisonne/ui';

export interface ConnectionErrorProps {
  /** `offline` = pas de réseau ; `unknown` = serveur injoignable / erreur inattendue. */
  variant: 'offline' | 'unknown';
  /** Relance le chargement (re-fetch du profil). */
  onRetry: () => void;
}

const COPY = {
  offline: {
    title: 'Pas de connexion internet',
    description: 'Vérifie ton Wi-Fi ou tes données mobiles, puis réessaie.',
  },
  unknown: {
    title: 'Connexion impossible',
    description: 'Le serveur ne répond pas pour le moment. Réessaie dans un instant.',
  },
} as const;

/**
 * Écran plein affiché quand le profil n'a pas pu être chargé faute de réseau.
 * Mobile-first : message centré, bouton d'action `w-full` plafonné sur grand écran.
 */
export function ConnectionError({ variant, onRetry }: ConnectionErrorProps) {
  const { title, description } = COPY[variant];

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5 px-6 text-center">
      <div className="bg-ink-100 flex h-16 w-16 items-center justify-center rounded-full">
        <WifiOff className="text-ink-400 h-8 w-8" aria-hidden />
      </div>

      <div className="space-y-1">
        <h1 className="font-display text-ink-900 text-lg font-extrabold">{title}</h1>
        <p className="text-ink-500 mx-auto max-w-xs font-sans text-sm">{description}</p>
      </div>

      <Button onClick={onRetry} fullWidth className="max-w-xs">
        Réessayer
      </Button>
    </div>
  );
}
